module.exports = __webpack_public_path__ + "img/violet_010.1f28b31f.png";